import { render, staticRenderFns } from "./setCards.vue?vue&type=template&id=02ede9e3&scoped=true&"
import script from "./setCards.vue?vue&type=script&lang=js&"
export * from "./setCards.vue?vue&type=script&lang=js&"
import style0 from "./setCards.vue?vue&type=style&index=0&id=02ede9e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ede9e3",
  null
  
)

export default component.exports